import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

// Registra o service worker
if ('serviceWorker' in navigator && environment.production) {
  navigator.serviceWorker
    .register('ngsw-worker.js')
    .then((registration) => {
      console.log('[DEBUG] Service Worker registrado com sucesso!');
    })
    .catch((error) => {
      console.error('[DEBUG] Falha ao registrar o Service Worker:', error);
    });
}
